import debounce from 'lodash/debounce';
import { ROLLING_RESTART_TIMEOUT } from './constants';

export default () => {
  const refreshPage = debounce(() => window.location.reload(), ROLLING_RESTART_TIMEOUT);

  window.addEventListener('load', refreshPage);
  window.addEventListener('click', refreshPage);
};
